import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import cn from 'classnames';
import { isObject } from 'lodash-es';
import { Row, Tooltip } from 'seagull';
import { Edit } from 'seagull/icons';
import ServicePriceEditorPopover from '~/components/ServicePriceEditorPopover/ServicePriceEditorPopover';
import PriceDisplay from '../PriceDisplay/PriceDisplay';
import { getPriceDisplayProps } from '../ServiceDetails.utils';
import styles from './EditablePrice.module.scss';
export default function EditablePrice(props) {
    const { serviceWithChanges, service, testId, disableEditCost, isReadOnly, showDiscountError, onChangeService, serviceOrigin, agreementData } = props;
    const [priceEditorOpen, setPriceEditorOpen] = useState(false);
    const editorButtonRef = useRef(null);
    function tooltip() {
        if (showDiscountError) {
            return {
                testId: 'discount-error-tooltip',
                title: "When the billing trigger is set to 'In stages', the discount can only be applied as a percentage"
            };
        } else if (isObject(disableEditCost)) {
            return {
                testId: 'disabled-tooltip',
                title: disableEditCost.disabledTooltip
            };
        } else {
            return undefined;
        }
    }
    const isDisabled = isReadOnly || !!disableEditCost;
    const showEditButton = !isReadOnly;
    const PriceButton = showEditButton ? /*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({}, tooltip() || {
        title: ''
    }), {
        children: /*#__PURE__*/ _jsx("div", {
            ref: editorButtonRef,
            role: "button",
            "data-testid": testId + 'inline-edit-price-button',
            "data-error": showDiscountError.toString(),
            "aria-disabled": isDisabled,
            onClick: !isDisabled ? ()=>setPriceEditorOpen(true) : undefined,
            className: cn(styles.priceButtonContainer, {
                [styles.clickable]: !isDisabled
            }),
            children: /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(PriceDisplay, _object_spread_props(_object_spread({}, getPriceDisplayProps(serviceWithChanges, agreementData)), {
                        error: showDiscountError,
                        testId: testId + 'inline-edit-'
                    })),
                    /*#__PURE__*/ _jsx(Row, {
                        className: styles.editIconButton,
                        testId: testId + 'inline-price-edit',
                        children: /*#__PURE__*/ _jsx(Edit, {})
                    })
                ]
            })
        })
    })) : /*#__PURE__*/ _jsx(PriceDisplay, _object_spread_props(_object_spread({}, getPriceDisplayProps(serviceWithChanges, agreementData)), {
        error: showDiscountError,
        testId: testId + 'inline-edit-'
    }));
    const PriceEditor = /*#__PURE__*/ _jsx(ServicePriceEditorPopover, {
        serviceOrigin: serviceOrigin,
        onServiceChange: onChangeService,
        serviceWithChanges: serviceWithChanges,
        service: service,
        editorAnchor: editorButtonRef.current,
        isOpen: priceEditorOpen,
        setIsOpen: setPriceEditorOpen
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            PriceButton,
            showEditButton && PriceEditor
        ]
    });
}
